import { motion } from "framer-motion";

const AnimatedUserCount = ({ initialNumber }) => {
  return (
    <motion.span
      className="font-bold text-gray-900"
      initial={{ y: 0 }}
      animate={{
        y: [0, -3, 0], // smooth vertical movement
      }}
      transition={{
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    >
      {initialNumber}
    </motion.span>
  );
};

export default AnimatedUserCount;
